import * as d3 from 'd3-selection'

export default function (container, val, clazz, numerator, max) {
  var hidden = d3.select(container.parentNode)
                 .append('text')
                 .classed(clazz, true)
                 .text(val)
    , size = Math.min(max, numerator / hidden.node().getComputedTextLength() * 15)

  hidden.remove()
  return size + 'px'
}
